module.exports = __webpack_public_path__ + "static/battery-538af9832b114c688846758c11c42882.png";